import {DateValue, useDateField, useDateSegment, useLocale} from 'react-aria';
import {DateFieldState, DateFieldStateOptions, useDateFieldState} from 'react-stately';
import type {DateSegment as DateSegmentType} from 'react-stately';
import {createCalendar} from '@internationalized/date';
import {useRef} from "react";
import {AriaDateFieldOptions} from '@react-aria/datepicker';

export function DateField(props: DateFieldStateOptions<DateValue> | AriaDateFieldOptions<DateValue>) {

    const {locale} = useLocale();
    const state = useDateFieldState({...props, locale, createCalendar});
    const ref = useRef<HTMLDivElement | null>(null);
    const {labelProps, fieldProps} = useDateField(props, state, ref);

    return (
        <div>
            <span {...labelProps}>{props.label}</span>
            <div {...fieldProps} ref={ref} className={'field-input'}>
                {state.segments.map((segment, i) => (
                    <DateSegment key={i} segment={segment} state={state}/>
                ))}
                {state.isInvalid && <span aria-hidden="true">🚫</span>}
            </div>
        </div>
    );
}

function DateSegment({segment, state}: {segment: DateSegmentType; state: DateFieldState}) {

    const ref = useRef<HTMLElement | null>(null);
    const {segmentProps} = useDateSegment(segment, state, ref);

    return (
        <span{...segmentProps} ref={ref} className={`segment mr-0.5 ${segment.isPlaceholder ? 'placeholder' : ''}`}>
            {segment.text}
        </span>
    );
}